import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="w-full flex justify-center items-center pt-60 lg:pt-44 pb-36">
      <div className=" md:w-3/5 w-4/5 text-center">
        <h1 className="md:text-[16vw] text-8xl font-robout text-[#ffffff]">
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </h1>
        <p className="xl:text-6xl md:text-5xl text-3xl  mt-2 mb-10 text-[#ffffff] font-robout">
          This page could not be found.
        </p>
        <Link
          data-aos="fade-right"
          to="/"
          aria-label="home page"
          className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
